import { QuestionnaireData } from '../../types';
import { StepId } from './steps';

interface ValidationResult {
  valid: boolean;
  error: string | null;
}

export function validateStep(stepId: StepId, data: Partial<QuestionnaireData>): ValidationResult {
  switch (stepId) {
    case 'businessType':
      if (!data.businessType || !data.businessSubType) {
        return { valid: false, error: 'Please select your business type and subtype' };
      }
      break;

    case 'industry':
      if (!data.industry) {
        return { valid: false, error: 'Please select your industry' };
      }
      break;

    case 'goals':
      if (!data.goals?.length) {
        return { valid: false, error: 'Please select at least one goal' };
      }
      break;

    case 'budget':
      if (!data.budget) {
        return { valid: false, error: 'Please select your budget range' };
      }
      break;

    case 'features':
      if (!data.features?.length) {
        return { valid: false, error: 'Please select at least one feature' };
      }
      break;

    case 'teamSize':
      if (!data.teamSize) {
        return { valid: false, error: 'Please select your team size' };
      }
      break;

    case 'businessStage':
      if (!data.businessStage) {
        return { valid: false, error: 'Please select your business stage' };
      }
      break;

    case 'technicalExpertise':
      if (!data.technicalExpertise) {
        return { valid: false, error: 'Please select your technical expertise level' };
      }
      break;
  }

  return { valid: true, error: null };
}